import {DeviceAlertConstant} from '../actionTypes/device.constant';
import axios from 'axios';
import {AuthHeader} from "../helper/auth.token"

export const fetchDevicesList = () => ({
    type : DeviceAlertConstant.FETCHING_DEVICES_LIST
})

export const receivedDevicesListResponse = (type, response) => ({
    type : type,
    response : response
})

export const getDevicesList = () => (dispatch) => {
    dispatch(fetchDevicesList())
    let url = `/api/device/`
    axios.get(url , {headers: {Authorization : AuthHeader()}})
        .then(response => {
            if(response.status === 200){
                dispatch(receivedDevicesListResponse(DeviceAlertConstant.RECEIVED_DEVICES_LIST, response))
            }
            else{
                dispatch(receivedDevicesListResponse(DeviceAlertConstant.FAILED_TO_RECEIVE_DEVICES_LIST, response))
            }
        })
        .catch(err => {
            dispatch(receivedDevicesListResponse(DeviceAlertConstant.FAILED_TO_RECEIVE_DEVICES_LIST, err))
            console.log(err)
        })
}